<template>
    <div v-if="mailtoHref"
         class="request-freight-quote"
    >
        <span class="request-freight-quote__text">
            {{ $t('freightQuote.banner.prompt') }}
        </span>
        <a :href="mailtoHref"
           class="request-freight-quote__link"
        >
            {{ $t('freightQuote.banner.linkText') }}
        </a>
        <span class="request-freight-quote__text">
            {{ $t('freightQuote.banner.suffix') }}
        </span>
    </div>
</template>

<script>
import constants from '@/core/constants';

export default {
    name: 'RequestFreightQuote',
    props: {
        clientName: {
            type: String,
            required: true,
        },
        clientId: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            config: null,
        };
    },
    computed: {
        mailtoHref() {
            if (!this.config) {
                return undefined;
            }

            const subject = this.config.subject
                .replace('{clientName}', this.clientName)
                .replace('{clientId}', this.clientId);

            const params = [`subject=${encodeURIComponent(subject)}`, `body=${encodeURIComponent(this.config.body)}`];

            if (this.config.cc) {
                params.push(`cc=${encodeURIComponent(this.config.cc)}`);
            }

            if (this.config.bcc) {
                params.push(`bcc=${encodeURIComponent(this.config.bcc)}`);
            }

            return `mailto:${this.config.to}?${params.join('&')}`;
        },
    },
    async created() {
        try {
            const response = await fetch(constants.freightQuoteRequestConfigUrl);
            this.config = await response.json();
        } catch (error) {
            this.config = null;
        }
    },
};
</script>

<style lang="scss" scoped>
.request-freight-quote {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 4px;
    padding-top: 5px;
    padding-right: 10px;
    padding-bottom: 5px;
    padding-left: 10px;
    border-radius: 14px;
    background-color: #ffffff54;
    color: $color-white;
    font-size: $font-size-sm;

    &__link {
        color: $color-link-active-on-bg;
        font-weight: 700;
        text-decoration: underline;

        &:hover {
            color: $color-link-hover;
        }
    }
}
</style>
